export default (color, amount) =>
  `#${color
    .replace(/^#/, '')
    .replace(/../g, c =>
      `0${Math.min(255, Math.max(0, parseInt(c, 16) + amount)).toString(
        16,
      )}`.substr(-2),
    )}`;
